import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import download from '../images/download-doc.svg';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === "light"
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)'
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)'
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

class EnhancedTableToolbar extends React.Component {
  render() {
    const {
      NumRowsSelected,
      classes,
      OnConfirmDeleteUser,
      OnGenerateCSVReport,
      IsButtonDisabled,
      t,
    } = this.props;

    return (
      <React.Fragment>
        <Toolbar
          className={classNames(classes.root, {
            [classes.highlight]: NumRowsSelected > 0,
          })}>
          <div className={classes.title}>
            {NumRowsSelected > 0 ? (
              <Typography color='inherit' variant='subheading'>
                {NumRowsSelected} {t("Report.inActive.SelectedRowCount")}
              </Typography>
            ) : null}
          </div>
          <div className={classes.spacer} />
          <div className={classes.actions}>
            {NumRowsSelected >= 1 ? (
              <Tooltip key='delete' title={t("Report.inActive.DeleteTooltip")}>
                <IconButton aria-label='Delete' onClick={OnConfirmDeleteUser}
                  sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } })}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip key='exportcsv' title={t("Report.inActive.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label='ExportCSV'
                  onClick={OnGenerateCSVReport}
                  disabled={IsButtonDisabled}>
                  <img
                    alt='download'
                    src={download}
                    style={{
                      height: '32px',
                      width: '32px',
                      cursor: 'pointer',
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </Toolbar>
      </React.Fragment>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  NumRowsSelected: PropTypes.number.isRequired,
};

export default withStyles(toolbarStyles)(withTranslation()(EnhancedTableToolbar));



// WEBPACK FOOTER //
// ./src/components/reports/users-inactive-report/EnhancedTableToolBar.index.js